module.exports = __webpack_public_path__ + "img/ico_control.38af849d.svg";